export class RugbyActivity {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.logo = form.logo;
      this.status = form.status;
      this.clubName = form.clubName;
      this.leaderName = form.leaderName;
      this.eventType = form.eventType;
      this.name = form.name;
      this.region = form.region;
      this.beginTime = form.beginTime;
      this.endTime = form.endTime;
      this.registrationBeginTime = form.registrationBeginTime;
      this.registrationEndTime = form.registrationEndTime;
      this.participationNumber = form.participationNumber;
      this.alternateTotalNumber = form.alternateTotalNumber;
      this.address = form.address;
      this.content = form.content;
      this.announcement = form.announcement;

      this.location =
        form.latitude && form.longitude
          ? `${form.latitude},${form.longitude}`
          : "0,0";

      this.activityImageVO = form.activityImageVO || {};
    } else {
      this.clear();
    }
  }

  get location() {
    if (this.latitude && this.longitude) {
      return `${this.latitude},${this.longitude}`;
    } else {
      return "0,0";
    }
  }

  set location(location) {
    if (location) {
      this.latitude = location.split(",")[0];
      this.longitude = location.split(",")[1];
    } else {
      this.latitude = 0;
      this.longitude = 0;
    }
  }

  clear() {
    this.id = null;
    this.logo = null;
    this.status = null;
    this.clubName = null;
    this.leaderName = null;
    this.eventType = null;
    this.name = null;
    this.region = null;
    this.beginTime = null;
    this.endTime = null;
    this.registrationBeginTime = null;
    this.registrationEndTime = null;
    this.participationNumber = 0;
    this.alternateTotalNumber = 0;
    this.address = null;
    this.content = null;
    this.announcement = null;

    this.activityImageVO = {};
  }
}
